import { useEffect, useState } from 'react';
import accountApis from '../../../../../services/accountApis';
import { IGetPackageSmsDashboardResponse } from '../types';
import { AxiosResponse } from 'axios';

const useGetPackageSms = (shopId: string, isLazy = false) => {
  const [data, setData] = useState<IGetPackageSmsDashboardResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res: AxiosResponse<{ data: IGetPackageSmsDashboardResponse }> = await accountApis.getSMSPackageDashboard(shopId);
      setData(res?.data?.data);
    } catch (error) {
      console.error('Error fetching SMS package dashboard:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!isLazy && shopId) {
      fetchData();
    }
  }, [shopId]);

  return { data, loading };
};

export default useGetPackageSms;
